import { render, staticRenderFns } from "./disfinancingtrade.vue?vue&type=template&id=8a90a7f0&scoped=true&"
import script from "./disfinancingtrade.vue?vue&type=script&lang=js&"
export * from "./disfinancingtrade.vue?vue&type=script&lang=js&"
import style0 from "./disfinancingtrade.vue?vue&type=style&index=0&lang=less&"
import style1 from "./disfinancingtrade.vue?vue&type=style&index=1&id=8a90a7f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a90a7f0",
  null
  
)

export default component.exports